"use client";

import { useSearchParams } from "next/navigation";
import { ajanlatkeresBekuldese } from "@/lib/actions/ajanlatkeres";

type Props = {
  forras?: "WEBOLDAL_AJANLATKERES" | "WEBOLDAL_KAPCSOLAT" | "WEBOLDAL_HIBABEJELENTES";
  visszaOldal?: string;
  masodlagosValasztoCimke?: string;
  masodlagosValasztoOpciok?: string[];
  igenyCimke?: string;
  gombSzoveg?: string;
};

export function AjanlatkeresForm({
  forras = "WEBOLDAL_AJANLATKERES",
  visszaOldal = "/ajanlatkeres",
  masodlagosValasztoCimke,
  masodlagosValasztoOpciok,
  igenyCimke = "Igény leírása",
  gombSzoveg = "Ajánlatkérés elküldése",
}: Props) {
  const params = useSearchParams();
  const siker = params.get("siker");
  const hiba = params.get("hiba");

  if (siker) {
    return (
      <div className="site-form">
        <p className="form-msg success">
          Köszönjük a megkeresést! Munkatársunk hamarosan felveszi Önnel a kapcsolatot.
        </p>
      </div>
    );
  }

  return (
    <form action={ajanlatkeresBekuldese} className="site-form cols-2">
      <input type="hidden" name="forras" value={forras} />
      <input type="hidden" name="vissza_oldal" value={visszaOldal} />

      {hiba && <p className="form-msg error">Kérjük, adja meg a nevét és e-mail címét.</p>}

      <div className="field">
        <label>Név / cégnév *</label>
        <input name="kapcsolat_nev" required />
      </div>
      <div className="field">
        <label>E-mail cím *</label>
        <input name="kapcsolat_email" type="email" required />
      </div>
      <div className="field">
        <label>Telefonszám</label>
        <input name="kapcsolat_telefon" type="tel" />
      </div>
      <div className="field">
        <label>Cím (a napelemes rendszer helyszíne)</label>
        <input name="cim_szabad_szoveg" />
      </div>
      {masodlagosValasztoOpciok && masodlagosValasztoOpciok.length > 0 && (
        <div className="field span-2">
          <input type="hidden" name="masodlagos_valaszto_cimke" value={masodlagosValasztoCimke || ""} />
          <label>{masodlagosValasztoCimke}</label>
          <select name="masodlagos_valaszto" defaultValue="">
            <option value="">Válasszon</option>
            {masodlagosValasztoOpciok.map((opcio) => (
              <option key={opcio} value={opcio}>
                {opcio}
              </option>
            ))}
          </select>
        </div>
      )}
      <div className="field span-2">
        <label>{igenyCimke}</label>
        <textarea name="igeny_leiras" />
      </div>
      <div className="field field-checkbox span-2">
        <input type="checkbox" name="helyszini_felmeres_szukseges" id="felmeres" />
        <label htmlFor="felmeres">Helyszíni felmérést kérek</label>
      </div>
      <div className="field span-2">
        <button type="submit" className="btn btn-primary">
          {gombSzoveg}
        </button>
      </div>
    </form>
  );
}
